import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { OpportunityService } from '../../../opportunity.service';
import { Observable } from 'rxjs';
import { Opportunity } from '@vendasta/sales-opportunities';
import { distinctUntilChanged, map, switchMap, take } from 'rxjs/operators';
import { FileInfo, FileUploadError } from '@vendasta/galaxy/uploader';
import { SalesOrdersService } from '@vendasta/sales-orders';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'sales-ui-attachments-card',
  templateUrl: './opportunity-attachments-card.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class OpportunityAttachmentsCardComponent implements OnInit {
  protected opportunity$: Observable<Opportunity>;
  attachmentsUploadUrl: string;
  files$: Observable<FileInfo[]>;
  constructor(
    private readonly updateService: OpportunityService,
    private readonly salesOrderService: SalesOrdersService,
    private readonly snackBar: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.opportunity$ = this.updateService.currentOpportunity$;
    this.attachmentsUploadUrl = this.salesOrderService.getUploadFileUrl();
    this.files$ = this.opportunity$.pipe(
      distinctUntilChanged(),
      map((opportunity) => {
        if (!opportunity.attachments) {
          return [];
        }
        return opportunity.attachments.map(
          (attachment) => ({ name: attachment.name, url: attachment.url } as FileInfo),
        );
      }),
    );
  }

  uploadFile(file: FileInfo): void {
    this.opportunity$
      .pipe(
        take(1),
        switchMap((opportunity) => {
          return this.updateService.addAttachmentToOpportunity(
            opportunity.opportunityId,
            opportunity.accountGroupId,
            file.name,
            file.url,
          );
        }),
      )
      .subscribe(
        () => {
          this.snackBar.openSuccessSnack('FRONTEND.SALES_UI.OPPORTUNITY_ATTACHMENT.ATTACHMENT_UPLOAD_SUCCESS');
        },
        () => {
          this.snackBar.openErrorSnack('FRONTEND.SALES_UI.OPPORTUNITY_ATTACHMENT.ATTACHMENT_ADDING_ERROR');
        },
      );
  }

  handleFileUploadError(err: FileUploadError): void {
    let errorMessage = 'FRONTEND.SALES_UI.ERRORS.ERROR_ATTACHMENT_GENERIC';
    switch (err.error.message) {
      case 'GALAXY.UPLOADER.ERROR.MAX_FILE_SIZE_EXCEEDED':
        errorMessage = 'FRONTEND.SALES_UI.ERRORS.ERROR_MAX_FILE_SIZE_EXCEEDED';
        break;
      case 'GALAXY.UPLOADER.ERROR.MAX_FILES_EXCEEDED':
        errorMessage = 'FRONTEND.SALES_UI.ERRORS.ERROR_MAX_FILES_EXCEEDED';
        break;
      case 'GALAXY.UPLOADER.ERROR.DUPLICATE_FILE_ATTEMPT':
        errorMessage = 'FRONTEND.SALES_UI.ERRORS.ERROR_DUPLICATE_FILE_ATTEMPT';
        break;
    }
    this.snackBar.openErrorSnack(errorMessage);
  }
}
